module.exports = __webpack_public_path__ + "static/media/modal-img.2af01147.png";